<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>
    
    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepaid50.png'>

      <div class="weui-cells__title">预计价格（仅作参考，以实际服务为准）</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>存储费用预计</p>
            </div>
            <div class="weui-cell__ft">{{order.data.estimated_week | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-show="order.data.ifSelfPick==0" >
            <div class="weui-cell__bd">
                <p>上门取货费用预计</p>
            </div>
            <div class="weui-cell__ft">{{order.data.estimated_week | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-show="order.data.ifSelfPick==0">
            <div class="weui-cell__bd">
                <p>上门送回费用预计</p>
            </div>
            <div class="weui-cell__ft">{{order.data.estimated_week | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>定金费用（可抵扣尾款费用）</p>
            </div>
            <div class="weui-cell__ft">{{depositAmount() | numeral('$0,0.00')}}</div>
        </a>

        <label class="weui-cell weui-check__label" @click="useCoupon()" v-show="!(ifCoupon || order.data.coupon)">
            <div class="weui-cell__bd">
                <p class="park-assist"> 点击使用优惠码 </p>
            </div>
        </label>
        <div class="weui-cell couponPd" v-show="ifCoupon || order.data.coupon">
            <div class="weui-cell__hd"><label class="weui-label">优惠码</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input text-right upperCase"  v-show="!order.data.couponLocked" type="text" placeholder="不区分大小写"  ref="couponRef" v-model="order.data.coupon">
            </div>
            <div class="weui-cell__ft"  v-show="!order.data.couponLocked">
                <button class="weui-vcode-btn" @click="applyCoupon()">提交使用</button>
            </div>

            <div class="weui-cell__ft" v-show="order.data.couponLocked">[{{order.data.coupon | uppercase}}] 尾款优惠 {{order.data.couponValue | numeral('$0')}} </div>
            <div class="weui-cell__ft" v-show="order.data.couponLocked">
                <button class="weui-vcode-btn" @click="cancelCoupon()">取消</button>
            </div>
        </div>
      </div>
      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step2')">
            <div class="weui-cell__bd">
                <p>联系方式</p>
            </div>
            <div class="weui-cell__ft">{{order.data.username + " " + order.data.userphone}}</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step1')">
            <div class="weui-cell__bd">
                <p>仓储体积</p>
            </div>
            <div class="weui-cell__ft">{{order.data.storage_scale}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step2')">
            <div class="weui-cell__bd">
                <p>存储时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.return_time_pending=="0" ? order.data.cal_week : order.data.estimated_week}}周</div>
        </a>
      </div>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step3')">
            <div class="weui-cell__bd">
                <p>取货方式</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.ifSelfPick==1">自行送往 - {{order.data.warehouse}} 仓库</div>
            <div class="weui-cell__ft" v-if="order.data.ifSelfPick==0">到家上门取货</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step2')">
            <div class="weui-cell__bd">
                <p>取货时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.pick_date | moment("YYYY年M月D日")}} {{pick_period}}</div>
        </a>
        <a v-if="order.data.ifSelfPick=='0'" class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step3')">
            <div class="weui-cell__bd">
                <p>取货地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.pick_street}}, {{order.data.pick_suburb}}, {{order.data.pick_state}}, {{order.data.pick_postcode}}</div>
        </a>
      </div>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step4')" >
            <div class="weui-cell__bd">
                <p>送回方式</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.ifSelfReturn==1">自行取回 - {{order.data.warehouse}} 仓库</div>
            <div class="weui-cell__ft" v-if="order.data.ifSelfReturn==0">到家上门送回</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step2')">
            <div class="weui-cell__bd">
                <p>送回时间</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.return_time_pending=='0'">{{order.data.return_date | moment("YYYY年M月D日")}} {{return_period}}</div>
            <div class="weui-cell__ft" v-else>待定，{{order.data.return_time_pending=="0" ? order.data.cal_week : order.data.estimated_week}}周后送回前再确定</div>
        </a>

        <a v-if="order.data.return_addr_pending=='0' && order.data.ifSelfReturn=='0'" class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step4')">
            <div class="weui-cell__bd">
                <p>送回地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.pick_street}}, {{order.data.pick_suburb}}, {{order.data.pick_state}}, {{order.data.pick_postcode}}</div>
        </a>
        <a v-if="order.data.return_addr_pending=='1' && order.data.ifSelfReturn=='0'" class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step4')">
            <div class="weui-cell__bd">
                <p>送回地址</p>
            </div>
            <div class="weui-cell__ft">待定，送回前确定</div>
        </a>
        <a v-if="order.data.return_addr_pending=='2' && order.data.ifSelfReturn=='0'" class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/warehouse-step4')">
            <div class="weui-cell__bd">
                <p>送回地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.return_street}}, {{order.data.return_suburb}}, {{order.data.return_state}}, {{order.data.return_postcode}}</div>
        </a>

      </div>
      <div class="weui-cells__title">留言备注</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="如果有特殊需求，请在此备注留言" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>
      <br>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="isSubmiting=true">创建订单</div>
        </div>
      </div>
      <div class="js_dialog" v-show="isSubmiting">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提醒</strong></div>
              <div class="weui-dialog__bd">请确保服务信息无误，提交后信息将被锁定，只能联系客服修改</div>
              <div class="weui-dialog__ft">
                  <div class="weui-dialog__btn weui-dialog__btn_default" @click="isSubmiting=false">关闭</div>
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="submitOrder()">确定提交</div>
              </div>
          </div>
      </div>
      <div class="js_dialog" v-show="couponValid">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">使用成功!</strong></div>
              <div class="weui-dialog__bd">优惠码有效，尾款可享优惠 ${{order.data.couponValue}}</div>
              <div class="weui-dialog__ft">
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="couponValid=false">好的</div>
              </div>
          </div>
      </div>
      <div class="js_dialog" v-show="couponInvalid">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">使用失败</strong></div>
              <div class="weui-dialog__bd">优惠码无效，请检查输入是否正确</div>
              <div class="weui-dialog__ft">
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="couponInvalid=false">好的</div>
              </div>
          </div>
      </div>
      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      <img :src="pixelURL('cangchu','step5')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      ifCoupon:false,
      isSending:false,
      isSubmiting:false,
      couponValid:false,
      couponInvalid:false,
    }
  },
  methods: {
    editData(url){
      localStorage.isEditing = '/warehouse-step5';
      this.$router.push(url);
    },
    useCoupon(text){
      this.ifCoupon = true;
      this.sleep(20).then(() => {
        this.$refs.couponRef.focus();
      });
    },
    cancelCoupon(){
      this.ifCoupon = true;
      this.orderUpdate('coupon','');
      this.orderUpdate('couponLocked',false);
    },
    applyCoupon(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;
        let couponText = {};
        couponText.coupon = this.order.data.coupon;

        this.axios.post(this.apiURL()+'/details/Storage/getCoupon', qs.stringify(couponText))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending=false;
            that.couponValid = true;
            that.orderUpdate('coupon',that.order.data.coupon);
            that.orderUpdate('couponLocked',true);
            that.orderUpdate('couponValue',response.data.data.relevance);
          }
          else{
            that.isSending=false;
            that.couponInvalid = true;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        this.$router.push('/warehouse-step4');
      }
    },
    submitOrder(){
      this.isSubmiting = false;
      
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('agency',this.order.data.agency);

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735974;

        orderObject.storage_scale = this.dataLint("storage_scale",orderObject.storage_scale);

        if(orderObject.ifSelfPick=='0'){
          orderObject.pick_floor = this.dataLint("floor",orderObject.pick_floor);
          orderObject.pick_parking = this.dataLint("parking",orderObject.pick_parking);
        }
        if(orderObject.ifSelfReturn=='0' && orderObject.return_addr_pending=='0'){
          orderObject.return_floor = this.dataLint("floor",orderObject.return_floor);
          orderObject.return_parking = this.dataLint("parking",orderObject.return_parking);
        }

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.username;
            orderObject.member_phone = orderObject.userphone;
        }

        if(orderObject.ifSelfReturn=='0' && orderObject.return_addr_pending=='0'){
            orderObject.return_street = orderObject.pick_street;
            orderObject.return_suburb = orderObject.pick_suburb;
            orderObject.return_postcode = orderObject.pick_postcode;
            orderObject.return_floor = orderObject.pick_floor;
            orderObject.return_parking = orderObject.pick_parking;
        }

        orderObject.pick_date = new Date(orderObject.pick_date);
        orderObject.pick_date = Vue.filter('moment')(orderObject.pick_date,"YYYY-MM-DD");

        if(orderObject.return_time_pending=='0'){
          orderObject.return_date = new Date(orderObject.return_date);
          orderObject.return_date = Vue.filter('moment')(orderObject.return_date,"YYYY-MM-DD");
        }
        if(orderObject.return_time_pending=='1'){
          let pdate = new Date(orderObject.pick_date);
          let rdate = new Date();
          rdate.setDate(pdate.getDate()+orderObject.estimated_week*7);
          orderObject.return_date = new Date(rdate);
          orderObject.return_date = Vue.filter('moment')(orderObject.return_date,"YYYY-MM-DD");
        }
        
        orderObject['order_source'] = '3';
        if(orderObject.return_addr_pending=="2"){
          orderObject.return_addr_pending="0";
        }

        if(orderObject.return_time_pending=="0"){
          orderObject.estimated_week = orderObject.cal_week;
        } 

        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            localStorage.removeItem('order');
            that.$router.push('/order-prepay?id='+response.data.data.order_number+'&status=0&amount='+that.depositAmount());
            if(response.data.data.accoun_status>=0){
              localStorage.account_status = response.data.data.accoun_status;
            }
            if(response.data.data.accoun_status == 2){
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.phone;
              localStorage.member_name = response.data.data.name;
              localStorage.tempPasswd = response.data.data.password;
            }
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
    dataLint(name,value){
      let result ="";

      if (name == "storage_scale"){
        switch (value) {
          case "1":
            result = "1588833175"
            break;
          case "2":
            result = "1588833189"
            break;
          case "3":
            result = "1588833203"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "parking") {
        switch (value) {
          case "1":
            result = "1551410080"
            break;
          case "2":
            result = "1551410087"
            break;
          case "3":
            result = "1551410093"
            break;
          default:
            console.log("6");
        }
      }

      if (name == "floor") {
        switch (value) {
          case "1":
            result = "1551412462"
            break;
          case "2":
            result = "1551412475"
            break;
          case "3":
            result = "1551412486"
            break;
          case "4":
            result = "1551412499"
            break;
          case "5":
            result = "1551412509"
            break;
          case "6":
            result = "1551412525"
            break;
          case "7":
            result = "1551412535"
            break;
          default:
            console.log("7");
        }
      }
      return result;
    },
  },
  components: {
  },
  computed: {
    pick_period: function () {
      let result = '';
      switch (this.order.data.pick_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    return_period: function () {
      let result = '';
      switch (this.order.data.return_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "warehouse"){
        this.order = localParsed;
      }
      else{
        // this.$router.push('/');
      }
    }
    else{
      // this.$router.push('/');
    }
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}

.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}


.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/warehouse/step5.vue